import clsx from 'clsx';

const FlowContainer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={clsx(
      'cur-mx-auto cur-w-full cur-max-w-[385px] cur-px-4 sm:cur-pb-0',
      className,
    )}
  >
    {children}
  </div>
);

export { FlowContainer };
